import Box from '@mui/material/Box';
import styled from "@mui/system/styled"
import Image from 'next/image';
import styles from "./LogoButton.module.css"



const InnerLogoLetterContainer = styled('div')(({theme})=>({
  fontSize:30,
  fontFamily:`'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif`,
  color: "#CEC6C6",
  fontStyle:"italic"
}))

const LetterContainer = styled('div')(({theme})=>({
  width: 33,
    height: 33,
    border:`3px solid #8CBED6`,
    display: "flex",
    alignItems: "center",
    margin: 1,
    justifyContent: "center",
    position: "relative"
}))


export default function LogoButton(){
    const useCustomLogo = process.env.USE_CUSTOM_LOGO
    const logo = process.env.LOGO
    return (
    useCustomLogo && logo ?
    <Box border={"solid GrayText"} borderRadius={2} padding={1} bgcolor={"white"} display={"flex"} sx={{width:220,justifyContent:"center"}}>
      <Image
    src={`/${logo}`}
    height={30}
    width={120}
    alt="Logo"
    />
    </Box>
    :
    <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} marginTop={1}>
        
        
        
        <Box
          className={styles.container}  
        >
                <LetterContainer sx={{borderTopLeftRadius:15,borderBottomRightRadius:15}}>
                    <InnerLogoLetterContainer>
                        B
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        A
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        N
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        K
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        A
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        Y
                    </InnerLogoLetterContainer>
                </LetterContainer>
                <LetterContainer>
                    <InnerLogoLetterContainer>
                        0
                    </InnerLogoLetterContainer>
                </LetterContainer>
        </Box>
        
        </Box>);
}
